export const BrandLogo = ({ dark = false, showBaseline = true, className = "" }) => {
  return (
    <div className={`flex flex-col ${className}`}>
      <div className="flex items-baseline gap-1">
        <span className={`font-display font-extrabold text-2xl tracking-tight ${dark ? "text-white" : "text-ink"}`}>
          Pulse
        </span>
        <span className="w-2 h-2 rounded-full bg-coral inline-block mb-0.5" />
      </div>
      {showBaseline && (
        <span className={`text-[11px] tracking-[0.15em] uppercase ${dark ? "text-white/50" : "text-ink-light/70"}`}>
          Studio éditorial LinkedIn
        </span>
      )}
    </div>
  );
};

export default BrandLogo;
